module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-mobile-es.8690dcb6.webp";